import { PageHeaderBlackText } from '@elements/Common';
import { useDynamicContext } from '@page-components/shipment/DynamicFields';
import { FlexNestedTable } from './FlexNestedTable';
import { CommonUtility } from '@utility/common';

export function FlexNestedField({
  addNestedField,
  errors,
  item,
  onChange,
  removeNestedField,
  values,
}) {
  // @ts-expect-error - TS2339: Property 'readOnly' does not exist on type '{}'.
  const { readOnly } = useDynamicContext() || {};
  return (
    <>
      <div className="sk:w-full sk:flex-none sk:px-4 sk:flex! sk:items-center! sk:justify-between!">
        {item.label && (
          <PageHeaderBlackText className="sk:mt-3.5! sk:mb-1!">
            {item.label}
          </PageHeaderBlackText>
        )}
      </div>
      <FlexNestedTable
        isBox={item.rowClass === 'box-container'}
        allowActions={!readOnly && item.multiple}
        label={item.label}
        errors={errors}
        fields={item.nestedFields}
        defaultValues={item.default}
        onChange={value => onChange(item.name, value)}
        onPressEnter={() => addNestedField(item)}
        removeNestedField={index => removeNestedField(item.name, index)}
        rows={CommonUtility.isValidArray(values) ? values : []}
      />
    </>
  );
}
